import { useIsAuthenticated } from "@azure/msal-react";
import {
  SituationModel,
  Visibility,
  publishSituation,
  unpublishSituation,
} from "../../clients/BackOfficeApi";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { Flex } from "@chakra-ui/react";
import { useCallback } from "react";
import { ActionButton } from "../../elements/ActionButton";

interface Props {
  situation: SituationModel;
  forCell?: boolean;
  onChange?: () => void;
}
export function SituationActions({
  situation,
  forCell = false,
  onChange = () => {},
}: Props) {
  const isAuthenticated = useIsAuthenticated();

  const buttonVariant = forCell ? "link" : "solid";
  const direction = forCell ? "column" : "row";

  const publish = useCallback(
    (situationId: number) => {
      if (!isAuthenticated) return;

      publishSituation({
        path: { situationId },
        throwOnError: true,
      })
        .catch((e) => {
          console.error("Failed to publish situation", e);
        })
        .finally(() => {
          onChange();
        });
    },
    [isAuthenticated, onChange],
  );

  const depublish = useCallback(
    (situationId: number) => {
      if (!isAuthenticated) return;

      unpublishSituation({
        path: { situationId },
        throwOnError: true,
      })
        .catch(() => {})
        .finally(onChange);
    },
    [isAuthenticated, onChange],
  );

  return (
    <Flex direction={direction} gap={2} minW={24}>
      {situation.visibility === Visibility.UNPUBLISHED && (
        <ActionButton
          color="green.500"
          icon={<ViewIcon />}
          onClick={() => publish(situation.id)}
          title="Publiceren"
          variant={buttonVariant}
        />
      )}
      {situation.visibility === Visibility.PUBLISHED && (
        <ActionButton
          color="blue.500"
          icon={<ViewOffIcon />}
          onClick={() => depublish(situation.id)}
          title="Depubliceren"
          variant={buttonVariant}
        />
      )}
    </Flex>
  );
}
